import FundingInHouse from './FundingInHouse';

export default FundingInHouse;
